import { useState, memo } from "react";
import { Modal, Dropdown } from "react-bootstrap";

import BubbleComponent from "./BubbleComponent";
import InputComponent from "./InputComponent";
import ButtonComponent from "./ButtonComponent";

import clickElementHandler from "../utils/clickElementHandler";

import Channel from "../typings/Channel";
import SetState from "../typings/SetState";

type MultiMessageModalProps = {
  show: boolean;
  onClose: SetState<boolean>;
  onSendMessageHandler: (message: string, tags?: string[]) => void;
  channels: Channel[];
};

const MultiMessageModal = ({
  show,
  onClose,
  onSendMessageHandler,
  channels,
}: MultiMessageModalProps) => {
  const [channelBubbles, setChannelBubbles] = useState<string[]>([]);
  const [message, setMessage] = useState("");

  const onSubmitHandler = (e: React.SyntheticEvent) => {
    e.preventDefault();
    onSendMessageHandler(message, [...channelBubbles]);
    onClose(false);
    setChannelBubbles([]);
    setMessage("");
  };

  let channelBubblesItems = channelBubbles.map((channelName) => {
    return (
      <BubbleComponent
        key={channelName}
        onClick={() => {
          clickElementHandler(channelName, channelBubbles, setChannelBubbles);
        }}
      >
        {channelName}
      </BubbleComponent>
    );
  });

  let channelDropdownItems = channels.map((channel) => {
    if (!channelBubbles.includes(channel.name)) {
      return (
        <Dropdown.Item
          onClick={() => {
            clickElementHandler(
              channel.name,
              channelBubbles,
              setChannelBubbles
            );
          }}
          key={channel.name}
        >
          {channel.name.substring(1)}
        </Dropdown.Item>
      );
    }

    return null;
  });

  return (
    <Modal show={show} onHide={() => onClose(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Multiple channels sending</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <InputComponent
          hideMultiMessageButton
          hideSendButton
          setValue={setMessage}
          value={message}
        />
        <Modal.Footer>
          {channelBubblesItems}
          <Dropdown>
            <Dropdown.Toggle
              style={{ backgroundColor: "#222c4a", borderColor: "#222c4a" }}
              size="sm"
              id="dropdown-basic"
            >
              Add Channels
            </Dropdown.Toggle>
            <Dropdown.Menu>{channelDropdownItems}</Dropdown.Menu>
          </Dropdown>
        </Modal.Footer>
        <Modal.Footer>
          <ButtonComponent onClick={() => onClose(false)}>
            Close
          </ButtonComponent>
          <ButtonComponent
            disabled={channelBubbles.length === 0 || message.length === 0}
            type="submit"
            onClick={(e) => onSubmitHandler(e)}
          >
            <i className="fas fa-paper-plane"></i> Send
          </ButtonComponent>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default memo(MultiMessageModal);
